import { Data } from 'plotly.js-dist-min';

export interface GraphBlockDataType {
  lineChart: Data[];
  otherChart: Data[];
}